import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import ChampionshipTeamCardHeader from '../team-card/championship-team-card-header';
import { CardContainer } from '../team-card/styles';
import { AnnouncedTeam } from '../../../domain/interfaces/AnnouncedTeam';
import UDText from '../../../../ud-ui/components/text';
import StyledSelect from '../../styled-select';
import { useDispatch } from 'react-redux';
import { upsertChampionshipTeamApplication } from '../../../store/championshipTeams/actions';
import { AnnouncedTeamStatus } from '../../../domain/enums/AnnouncedTeamStatus';

type ChampionshipTeamCardProps = {
  index: number;
  championshipTeam: AnnouncedTeam;
  isUpdating?: boolean;
};

const ChampionshipTeamCard = ({
  index,
  championshipTeam,
  isUpdating,
}: ChampionshipTeamCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCardClick = useCallback(() => {
    navigate(`${championshipTeam.id}`);
  }, [championshipTeam.id, navigate]);

  const handleStatusChange = useCallback(
    (option) => {
      dispatch(
        upsertChampionshipTeamApplication({
          teamId: championshipTeam.id,
          status: option.value,
        })
      );
    },
    [championshipTeam.id, dispatch]
  );

  const prefixComponent = (
    <UDText type="subhead" className="bold ml-3 mr-6">
      {index}
    </UDText>
  );

  const applicationDate = championshipTeam.applicationDate
    ? new Date(championshipTeam.applicationDate)
    : new Date();

  const bodyComponent = (
    <div
      className="d-flex justify-content-between align-items-center"
      style={{ flexBasis: '50%' }}
    >
      <UDText type="subhead" style={{ flexBasis: '30%' }}>
        {format(applicationDate, 'dd.MM.yyyy')}
      </UDText>
      <div className="d-flex align-items-center justify-content-between flex-grow-1">
        <UDText type="subhead" className="team-players-count">
          {t('teams.playersCount', {
            count: championshipTeam.applications.length,
          })}
        </UDText>
        <StyledSelect
          isLoading={isUpdating}
          isDisabled={isUpdating}
          placeholder="Выбрать"
          options={[
            {
              value: AnnouncedTeamStatus.ACCEPTED,
              label: 'Подтвердить',
            },
            {
              value: AnnouncedTeamStatus.DECLINED,
              label: 'Отклонить',
            },
          ]}
          onChange={handleStatusChange}
        />
      </div>
    </div>
  );

  return (
    <CardContainer className="mb-4 last-mb-0" onClick={handleCardClick}>
      <ChampionshipTeamCardHeader
        isExpanded={false}
        containerProps={{ style: { cursor: 'pointer' } }}
        teamName={championshipTeam.name}
        teamLogo={championshipTeam.logo?.url}
        prefixComponent={prefixComponent}
        actions={bodyComponent}
      />
    </CardContainer>
  );
};

export default ChampionshipTeamCard;
